export const listFields = [
  {
    name: 'actinobacteria',
    color: 'rgba(255, 99, 132, 1)'
  },
  {
    name: 'firmicutes',
    color: 'rgba(54, 162, 235, 1)'
  },
  {
    name: 'bacteroidetes',
    color: 'rgba(153, 102, 255, 1)'
  },
  {
    name: 'proteobacteria',
    color: 'rgba(255, 206, 86, 1)'
  },
  {
    name: 'other',
    color: 'rgba(83, 102, 255, 1)'
  },
  {
    name: 'cyanobacteria',
    color: 'rgba(75, 192, 192, 1)'
  },
  {
    name: 'fusobacteriota',
    color: 'rgba(255, 159, 64, 1)'
  },
  {
    name: 'patescibacteria',
    color: 'rgba(199, 199, 199, 1)'
  },
  {
    name: 'desulfobacterota',
    color: 'rgba(83, 102, 255, 1)'
  },
  {
    name: 'spirochaetota',
    color: 'rgba(255, 99, 132, 1)'
  },
  {
    name: 'synergistota',
    color: 'rgba(54, 162, 235, 1)'
  }
];
